<template>
  <v-icon
    color="indigo"
    class="linkedin-icon"
    v-text="'mdi-linkedin'"
  />
</template>

<script>
export default {
  name: 'LinkedInIcon',
};
</script>

<style lang="scss" scoped>
.linkedin-icon {
  background-color: #fff;
  border-radius: 5px;
}
</style>
